import { IStackTokens } from '@fluentui/react';

export const edgeDistance = 16;

export const itemAlignmentStackTokensGap: IStackTokens = {
  childrenGap: 15,
};

export const itemAlignmentsStackPadding: IStackTokens = {
  padding: edgeDistance,
};

export const itemAlignmentsStackTokens: IStackTokens = {
  ...itemAlignmentStackTokensGap,
  ...itemAlignmentsStackPadding,
};

